const IsMac = () => {
    const mac = navigator.platform.indexOf('Mac') > -1 ? true : false;

    if (mac) {
        document.querySelector('body').classList.add('mac-os-system');
    }
};

export default IsMac;
